import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EmployeeModel } from "../models/employee.model";
import { ApiService } from "./api.service";
import { UserService } from "./user.service";
import { EmployeeInfoModel } from "../models/employee-info.model";
import { EmployeeNoteModel } from "../models/employee-note.model";
import { SetupEmployeeModel } from "../models/setup-employee.model";
import { PetHistoryModel } from "../models/pet-history.model";
import { RabiesVaccinationModel } from "../models/rabbies-vaccination.model";
import { SearchResult } from "../models/search-result.model";
import { BehaviorSubject, Subject } from "rxjs";
import { CategoryModel } from "../models/category.model";
import { AutoRecallModel } from "../models/auto-recall.model";
import { FileListModel } from "../models/file-list.model";
import { DiscountModel } from "../models/discount.model";
import { PrescriptionModel } from "../models/prescription.model";
import { CurrentUserModel } from "../models/current-user.model";
import { EmployeeDDListModel } from "../models/employee.model"; 
import { EmployeeSearchModel } from "../models/employee.model";
import { UserRolesModel } from "../models/user-roles.model"; 
declare var $: any;



@Injectable({
    providedIn: "root"
})
export class ManagerialService {

    private baseUrl: string = 'managerial';

    employees: EmployeeModel[] = [];
    recalls: AutoRecallModel[] = [];
    files: FileListModel[] = [];
    discounts: DiscountModel[] = [];
    prescriptions: PrescriptionModel[] = [];
    search: EmployeeModel = new EmployeeModel(0, 0, '', '', '', '', '', '', '', '', '', 0, '', '', '',0, 0);
    employee: SetupEmployeeModel = new SetupEmployeeModel(new EmployeeModel(0, 0, '', '', '', '', '', '', '', '', '', 0, '', '', '',0, 0), new EmployeeInfoModel(0, '', '', '', '', '', '', '', ''), new EmployeeNoteModel(0, 0, '', '', ''));
    pet_history: PetHistoryModel = new PetHistoryModel('', '', '', 0, 0);
    rabbies_vaccination: RabiesVaccinationModel = new RabiesVaccinationModel(0, 0, 0, '', false);
    category: CategoryModel = new CategoryModel(0, '', '', 0);
    subcategory: CategoryModel = new CategoryModel(0, '', '', 0);
    link: CategoryModel = new CategoryModel(0, '', '', 0);
    recall: AutoRecallModel = new AutoRecallModel(0, '', 0, '', 0, 1);
    file: FileListModel = new FileListModel('', '', 0);
    discount: DiscountModel = new DiscountModel(0, '', 0);
    prescription: PrescriptionModel = new PrescriptionModel('', '', '');
    employeeDDList: EmployeeDDListModel[] = [];
    employeeSearchList: EmployeeSearchModel[] = [];
    doctorDDList: EmployeeDDListModel[] = [];
    nurseDDList: EmployeeDDListModel[] = [];
    employee_roles: UserRolesModel[] = [];

    // userData: any = JSON.parse(localStorage['currentUser']); 

    setup_category = false;
    setup_subcategory = true;

    private messageGenericSource = new BehaviorSubject<boolean>(false);
    selectedGeneric = this.messageGenericSource.asObservable();

    private messageGenericCatSource = new BehaviorSubject<boolean>(false);
    selectedCatGeneric = this.messageGenericCatSource.asObservable();

    private messageGenericRecSource = new BehaviorSubject<boolean>(false);
    selectedRecGeneric = this.messageGenericRecSource.asObservable();

    private messageGenericFilSource = new BehaviorSubject<boolean>(false);
    selectedFilGeneric = this.messageGenericFilSource.asObservable();

    private messageGenericDscSource = new BehaviorSubject<boolean>(false);
    selectedDscGeneric = this.messageGenericDscSource.asObservable();

    private messageGenericPreSource = new BehaviorSubject<boolean>(false);
    selectedPreGeneric = this.messageGenericPreSource.asObservable();

    private notifyEmpSetupModal = new Subject<void>();
    notifyEmpSetupModalObservable = this.notifyEmpSetupModal.asObservable(); 
    notifyEmpSetupModalFunction() {  
        this.notifyEmpSetupModal.next();
    }

    constructor(
        private api: ApiService,
        private userService: UserService
    ) {

    }

    selectedGenericVar(message: boolean) {
        this.messageGenericSource.next(message)
    }

    selectedGenericCatVar(message: boolean) {
        this.messageGenericCatSource.next(message)
    }

    selectedGenericRecVar(message: boolean) {
        this.messageGenericRecSource.next(message)
    }

    selectedGenericFilVar(message: boolean) {
        this.messageGenericFilSource.next(message)
    }

    selectedGenericDscVar(message: boolean) {
        this.messageGenericDscSource.next(message)
    }

    selectedGenericPreVar(message: boolean) {
        this.messageGenericPreSource.next(message)
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    } 

    getEmployeesByParams(clinic_no: number | string) {
        let promise = new Promise((resolve, reject) => {
            if (this.search.page_number === 1)
                this.employees = [];

            this.api.get<EmployeeModel>(`${this.baseUrl}/getEmployeesByParams?clinic_no=${clinic_no}&employee_name=${this.sanitize(this.search.employee_name)}&username=${this.sanitize(this.search.username)}&category=${this.sanitize(this.search.category)}&active=${this.sanitize(this.search.active)}&employee_password=${this.sanitize(this.search.employee_password)}&employee_ssn=${this.sanitize(this.search.employee_ssn)}&date_terminated=${this.sanitize(this.search.date_terminated)}&paid_hourly=${this.sanitize(this.search.paid_hourly)}&role=${this.search.role}&page_number=${this.search.page_number}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.employees.push(...res.data.map((element) => {
                            return new EmployeeModel(0, element.employee_no, element.employee_name, element.username, element.category, element.active, element.employee_password, element.employee_ssn, element.doctor_license_no, element.date_terminated, element.paid_hourly, element.clinic, element.license_state, element.doctor_dea_no, element.doctor_dps_no,element.role, 0);
                        }));
                        resolve(1);
                    } else {
                        if (this.search.page_number === 1){
                            this.employees = [];
                        }
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupEmployee(rolesJson: string, webaccess: boolean) {
        let promise = new Promise((resolve, reject) => {
            const payload = JSON.parse(JSON.stringify(this.employee));
            const ph = payload.clientModel.paid_hourly;
            if (ph === true || ph === 'true') payload.clientModel.paid_hourly = true;
            else if (ph === false || ph === 'false') payload.clientModel.paid_hourly = false;
            else payload.clientModel.paid_hourly = null;
            payload.clientModel.role = String(payload.clientModel.role ?? '');
            this.api.post(`${this.baseUrl}/setupEmployee?rolesJson=${rolesJson}&webaccess=${webaccess}`, payload)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEmployeeInfoById() {
        let clinic_no = '';
            if (localStorage.currentUser && localStorage.token) {
                const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
                clinic_no = currentUser.clinic_no;
            }
        let promise = new Promise((resolve, reject) => {
            this.api.get<EmployeeInfoModel>(`${this.baseUrl}/getEmployeeInfoById?employee_no=${this.employee.clientModel.employee_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.employee.clientInfoModel = new EmployeeInfoModel(res.data.employee_no, res.data.address, res.data.city, res.data.state, res.data.zip, res.data.zip4, res.data.cellphone, res.data.office_phone, res.data.email);
                        this.employee.clientNoteModel = new EmployeeNoteModel(0, res.data.employee_no, res.data.note_text, '', '');
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getHistoryByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getHistoryByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_history = new PetHistoryModel(res.data.msg, res.data.hist, res.data.tag, res.data.seq_no, res.data.hist_seq);
                        resolve(1);
                    } else {
                        this.pet_history = new PetHistoryModel('', '', '', 0, 0);
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupRabiesVaccination() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupRabiesVaccination`, this.rabbies_vaccination)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.rabbies_vaccination = new RabiesVaccinationModel(0, 0, 0, '', false);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupCategory() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupCategory`, this.category)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.category = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupSubCategory() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupCategory`, this.subcategory)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.subcategory = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteCategory() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteCategory`, this.category)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.subcategory = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteSubCategory() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteSubCategory`, this.subcategory)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.subcategory = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupCategoryLink() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupCategoryLink`, this.link)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.link = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getAutoRecall(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getAutoRecall?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.recalls = [];
                        this.recalls.push(...res.data.map((element) => {
                            return new AutoRecallModel(element.recall_sequence, element.item_code, element.recall_days, element.recall_code, element.ask_user, element.recall_clinic);
                        }));
                        resolve(1);
                    } else {
                        this.recalls = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupAutoRecall() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupAutoRecall`, this.recall)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.recall = new AutoRecallModel(0, '', 0, '', 0, 1);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getFileList(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getFileList?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.files = [];
                        this.files.push(...res.data.map((element) => {
                            return new FileListModel(element.code_name, element.file_name, element.link_seq);
                        }));
                        resolve(1);
                    } else {
                        this.files = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupFileList() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupFileList`, this.file)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.file = new FileListModel('', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteFileList() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteFileList`, this.file)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.file = new FileListModel('', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    sanitize(text: string) {
        return text === null || text === undefined ? '' : text;
    }

    getDiscount() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getDiscount`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.discounts = [];
                        this.discounts.push(...res.data.map((element) => {
                            return new DiscountModel(element.discount_seq_no, element.discount_desc, element.discount_percent);
                        }));
                        resolve(1);
                    } else {
                        this.discounts = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupDiscount() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupDiscount`, this.discount)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.subcategory = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteDiscount() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteDiscount`, this.discount)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.subcategory = new CategoryModel(0, '', '', 0);
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPrescription() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPrescription`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.prescriptions = [];
                        this.prescriptions.push(...res.data.map((element) => {
                            return new PrescriptionModel(element.presc_code, element.presc_text, element.presc_reason_desc);
                        }));
                        resolve(1);
                    } else {
                        this.prescriptions = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getInventoryByCode() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getInventoryByCode?presc_code=${this.prescription.presc_code}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    setupPrescription() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPrescription`, this.prescription)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.prescription = new PrescriptionModel('', '', '');
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deletePrescription() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePrescription`, this.prescription)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        this.prescription = new PrescriptionModel('', '', '');
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getemployeeDDList() {
        let clinic_no = '';
            if (localStorage.currentUser && localStorage.token) {
                const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
                clinic_no = currentUser.clinic_no;
            }
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEmployeeDDList?clinic_no=${clinic_no}&category=`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.employeeDDList = res.data.map((element) => {
                            return new EmployeeDDListModel(element.employee_no, element.employee_name, element.category, element.active);
                        });
                        resolve(1);
                    } else {
                        this.employeeDDList = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    /** Lista de empleados para dropdown por clínica (ej. reporte Payroll Individual). */
    getEmployeeDDListForClinic(clinic_no: number) {
        const promise = new Promise((resolve) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEmployeeDDList?clinic_no=${clinic_no}&category=`)
                .subscribe({
                    next: (res: any) => {
                        if (res && res.results > 0) {
                            this.employeeDDList = res.data.map((element) => {
                                return new EmployeeDDListModel(element.employee_no, element.employee_name, element.category, element.active);
                            });
                            resolve(1);
                        } else {
                            this.employeeDDList = [];
                            resolve(0);
                        }
                    },
                    error: () => {
                        this.employeeDDList = [];
                        resolve(0);
                    },
                });
        });
        return promise;
    }

    getdoctorDDList() {
        let clinic_no = '';
            if (localStorage.currentUser && localStorage.token) {
                const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
                clinic_no = currentUser.clinic_no;
            }
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEmployeeDDList?category=doctor&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.doctorDDList = res.data.map((element) => {
                            return new EmployeeDDListModel(element.employee_no, element.employee_name, element.category, element.active);
                        });
                        resolve(1);
                    } else {
                        this.doctorDDList = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getnurseDDList() {
        let clinic_no = '';
            if (localStorage.currentUser && localStorage.token) {
                const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
                clinic_no = currentUser.clinic_no;
            }

        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEmployeeDDList?category=nurse&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.nurseDDList = res.data.map((element) => {
                            return new EmployeeDDListModel(element.employee_no, element.employee_name, element.category, element.active);
                        });
                        resolve(1);
                    } else {
                        this.nurseDDList = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkUsernameAvailable(username: string, employee_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/CheckUsernameAvailable?username=${username}&employee_no=${employee_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise;
    }

    getEmployeeSearchList(clinic_no: string, employee_name: string, username: string, active: string, role: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetSearchEmployee?clinic_no=${clinic_no}&employee_name=${employee_name}&username=${username}&active=${active}&role=${role}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.employeeSearchList = res.data.map((element) => {
                            return new EmployeeSearchModel(element.employee_no, element.employee_name, element.username, element.role);
                        });
                        resolve(1);
                    } else {
                        this.employeeSearchList = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
 
    selectEmployeeFunc(employee: EmployeeSearchModel, page_from: string) {
       if(page_from == 'timeclock'){ 
            this.userService.emp_timeclock_param.username = employee.username;
            this.userService.emp_timeclock_param.employee_no = employee.employee_no;
            this.userService.timeclock_param.clinic_no = this.userData.clinic_no; 

            console.log('employee selected for timeclock: ', this.userService.emp_timeclock_param);
       }

        $('#modalSearchEmployee').modal('toggle'); 
    }

    getEmployeeRoles(employee_no: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetEmployeeRoles?employee_no=${employee_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.employee_roles = res.data.map((element) => {
                            return new UserRolesModel(element.id, element.name, element.normalizedname, element.selected);
                        });
                        resolve(1);
                    } else {
                        this.employee_roles = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteEmployee(employee_no: number,clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteEmployee?employee_no=${employee_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                      resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    CheckUserExist(email:string){
        let promise = new Promise((resolve, reject) => {
            try{
                this.api.get<SearchResult>(`${this.baseUrl}/CheckUserExist?email=${email}`)
                .subscribe((res: any) => {
                    if (res && res.data > 0) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
            }
            catch(error){ 
                resolve(0);
            }
        });
        return promise;
    }
    

}